import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const Marque = () => {
    return (
        <Marquee gradient={false} speed={50} className="custom-marquee-wrapper">
            <h3 className="custom-marquee-text">
                <Sparkles size={18} style={{ marginRight: 8 }} />
                Spiracle Pest Management Services — professional, eco-friendly & cost-effective pest control across Mumbai and Suburbs
                <Sparkles size={18} style={{ marginLeft: 8 }} />
            </h3>
        </Marquee>
    );
};

export default Marque;
